import type { AdElement } from '@adflow/types';

import type { CanvasDocumentState } from './documentModel';
import { documentStateFromElements } from './persistence';

export { applyDocumentLayoutToAdElements } from './documentLayout';

/** Canonical document slice for canvas commands (includes all element types). */
export function documentFromEditorElements(
  elements: readonly AdElement[],
  animation: CanvasDocumentState['animation'] = null,
): CanvasDocumentState {
  return documentStateFromElements([...elements], animation, null);
}
